import React, { Component } from 'react'
import { heightFix } from '../../JS/heightFix'
import { connect } from 'react-redux'
import { getGuestRequestList, saveGuestRequest, setSubmitRequestWindow } from "../../action/guestRequest"
import { CMSPath } from '../../config/constant'
import { popupOpenClose, setDeviceLoginPage, getGuestInRoom } from '../../action/action'
import GuestRequestList from './GuestRequestList'
import { guestRequestColor } from '../../JS/setColors'

class GuestRequests extends Component {

  componentDidMount() {
    //heightFix();
    let sessionToken = localStorage.getItem('GuestJourneySessionToken');
    let room = localStorage.getItem("room");
    if (sessionToken) {

      //----------------------guest login pop up start-----------------------
      if (!this.props.guestDetails.locationId || !this.props.guestDetails.guestToken) {
        if (this.props.currentWidget.widgetType && (!room || room === "null")) {
          this.props.setDeviceLoginPage(true);
          console.log("room", room);
        }
      }
      //----------------------guest login popup end-----------------------

      //console.log("guestDetails=", this.props.guestDetails)
      this.props.getGuestInRoom(this.props.guestDetails);
      this.props.getGuestRequestList(this.props.guestDetails, this.props.currentWidget.storeSku);
    } else {
      console.log("no session token found.");
    }

    guestRequestColor(this.props.menuColor);
  }
  onSubmitClick = (event) => {
    let guestRequests = [], selceted, selector, selectedGuest, textNote, selectedGuestName;
    let sessionToken = localStorage.getItem('GuestJourneySessionToken');
    event.preventDefault();
    //console.log("Event", Event);
    //console.log("guestRequest3", selceted.checked);
    textNote = document.getElementById('guesstRequestNote').value;
    console.log("testNote", textNote);
    if (this.props.guestRequestList.qualityPlusRequestItems) {
      this.props.guestRequestList.qualityPlusRequestItems.map((iterator, index) => {
        selceted = document.getElementById(`guestRequest${iterator.id}`).checked;
        if (selceted) {
          guestRequests.push(iterator);
        }
      })
    }

    if (this.props.CheckedInGuest.length > 0) {
      selector = document.getElementById("GuestNameSelector");
      selectedGuestName = selector.options[selector.selectedIndex].value;
      console.log("selectedGuest", selectedGuestName);
      this.props.CheckedInGuest.map((iterator, index) => {
        if (iterator.guestName === selectedGuestName) {
          //console.log("guestName", iterator.guestName);
          selectedGuest = iterator
        }
      })
    }
    if (selectedGuest && selectedGuest && sessionToken) {
      if (guestRequests.length > 0) {
        //console.log("onSubmitClick");
        this.props.saveGuestRequest(selectedGuest, sessionToken, guestRequests, textNote);
      } else {
        this.props.popupOpenClose(true, "please select your request.");
      }
    }
    //console.log("guestRequests", guestRequests);
  }
  onCloseClick = (event) => {
    event.preventDefault();
    console.log("close.");
    document.getElementById('guesstRequestNote').value = null;
    if (this.props.guestRequestList.qualityPlusRequestItems) {
      this.props.guestRequestList.qualityPlusRequestItems.map((iterator) => {
        document.getElementById(`guestRequest${iterator.id}`).checked = false;
      })
    }
  }
  render() {
    return (
      <div id="ico-guest-services" class="contentSection overUnder columns center-v">
        <GuestRequestList
          guestRequestList={this.props.guestRequestList}
          stringConst={this.props.stringConst}
          setSubmitRequestWindow={this.props.setSubmitRequestWindow}
        />


        {
        /*
                <div id="guest-Req-col-1" class="col col-2 m-r25" style={{ background: "rgba(255,255,255,0.9)", marginRight: "0", padding: "1rem" }}>
            <div class="activity-heading all-caps">{props.stringConst.guestRequests}</div>
            <div class="scroll vertical">
                <div class="scroll-nav"><i class="fa fa-chevron-up"></i></div>
                <div id="scrollThumb" class="scroll-thumbs">
                    <ul>
                        {
                            props.guestRequestList.qualityPlusRequestItems ?
                                props.guestRequestList.qualityPlusRequestItems.map((iterator, index) => {
                                    return (
                                        <li>
                                            <div class="check-col">
                                                <input id={`guestRequest${iterator.id}`} type="checkbox" name="item1" />
                                            </div>
                                            <div class="img-col" style={{
                                                backgroundImage: `url("${CMSPath}${iterator.imagePath}")`,
                                                backgroundSize: "cover"
                                            }
                                            }></div>
                                            <div class="desc-col">
                                                <div class="title">{iterator.name}</div>
                                                <div class="desc">{iterator.description}</div>
                                            </div>
                                        </li>
                                    )
                                })
                                : null
                        }
                    </ul>
                </div>
                <div class="scroll-nav"><i class="fa fa-chevron-down"></i></div>
            </div>
        </div>
        <div id="guest-Req-col-2" class="col col-2 m-r25"
          style={{ background: "rgba(255,255,255,0.95)", marginRight: "0" }}>
          <div class="form">
            <form onSubmit={this.onSubmitClick}>
              <div class="form-item">
                <label for="client-name">Guest name</label>
                <select id="GuestNameSelector" name="client-name" class="select" style={{ width: "99%" }}>
                  {
                    this.props.CheckedInGuest.length > 0 ?
                      this.props.CheckedInGuest.map((iterator, index) => {
                        return (
                          <option value={`${iterator.guestName}`}>{iterator.guestName}</option>
                        )
                      }) : null
                  }
                </select>
              </div>
              <div class="form-item">
                <label for="client-comment">Note</label>
                <textarea id="guesstRequestNote" name="client-comment" rows="5" style={{ width: "99%" }}></textarea>
              </div>
              <div class="form-controls">
                <button type="submit" class="primary" >{this.props.stringConst.submit}</button>
                <button onClick={this.onCloseClick} class="secondary">{this.props.stringConst.cancel}</button>
              </div>
            </form>
          </div>
        </div>*/}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    stringConst: state.store.home.stringConst,
    guestDetails: state.store.home.guestDetails,
    guestRequestList: state.store.guestRequest.guestRequestList,
    CheckedInGuest: state.store.guestRequest.CheckedInGuest,
    currentWidget: state.store.sideNavBar.currentWidget,
    menuColor: state.store.home.MenuColor
  }
}
export default connect(
  mapStateToProps,
  {
    getGuestInRoom,
    getGuestRequestList,
    saveGuestRequest,
    popupOpenClose,
    setDeviceLoginPage,
    setSubmitRequestWindow
  }
)(GuestRequests);